import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (owner) return http.get(`/business/${owner}`, { headers: authHeader() });
  return http.get(`/business`, { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/business/${id}`, { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/business/${owner}`, data, { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/business/${id}`, data, { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/business/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/business`, { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/business?title=${title}`, { headers: authHeader() });
};

const getSummary = (params) => {
  return http.get(`/business/analytics/summary`, { headers: authHeader(), params });
};

const BusinessService = {
  getAll,
  get,
  getSummary,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default BusinessService;
